import en from './strings.en';

const ru = {
    payText: 'Оплатите, чтобы видеть контакты фирмы',
    loginText: 'Авторизуйтесь, чтобы видеть контакты фирмы'
};

export default { ru, en: { ...ru, ...en} };
